module.exports = __webpack_public_path__ + "static/logo-sharewater-c57e0901d879a8c544f7b995233d5e1a.png";